<template>
  <div class="homecontainer _homecontainer">
    <!--    '../../assets/imgs/main_img1.png'-->
    <GoodBriefInfo :fontcolor="'white'" :backgoundcolor="'rgb(250, 250, 250)'"
                   :imgsrc="getimgsrc(imglist[0])"/>
    <Services :titlename="$i18n.locale=='zh_HK'? title[1]:titleEn[1]" :type="1"
              :imgsrc="getimgsrc(imglist[1])"/>
<!--    <AboutUs :titlename="$i18n.locale=='zh_HK'? title[2]:titleEn[2]" :listdata="listaboutdata"/>-->
    <Products :titlename="$i18n.locale=='zh_HK'? title[3]:titleEn[3]" :fontcolor="'white'"
              :backgoundcolor="'rgb(250, 250, 250)'" :imgsrc="getimgsrc(imglist[3])" :listdata="listProdata"/>
    <Services :titlename="$i18n.locale=='zh_HK'? title[4]:titleEn[4]" :type="2"
              :imgsrc="getimgsrc(imglist[4])"  />
    <Services :titlename="$i18n.locale=='zh_HK'? title[5]:titleEn[5]" :type="3" style="z-index: 9;margin-top: -18%"
              :fontcolor="'white'" :backgoundcolor="'rgb(250, 250, 250)'" :imgsrc="getimgsrc(imglist[5])"/>
    <Mapposition :type="1"/>
  </div>
</template>

<script>
  import GoodBriefInfo from './homecomponents/GoodBriefInfo'
  import Services from "./homecomponents/services_home";
  import AboutUs from "./homecomponents/aboutUs_home";
  import Products from "./homecomponents/products_home";
  import Mapposition from '@/views/comcomponents/Mapposition'
  import {getListHome} from '@/api/home';


  export default {
    name: '',
    components: {
      Services,
      AboutUs,
      Products,
      GoodBriefInfo,
      Mapposition
    },
    data() {
      return {
        listhome: '',
        imglist: [],
        title:[],
        titleEn:[],
        listaboutdata:'',
        listProdata:'',

      }
    },
    created() {
      this.getListHome();
    },
    methods: {
      getListHome() {
        getListHome().then(response => {
          const data = response.data;
          this.listhome = data.data;
          this.listhome.forEach((item, index) => {
            // this.imglist = item.titleImg;
            this.title.push(item.title);
            this.titleEn.push(item.titleEn);
            this.imglist.push(item.titleImg);
          });
          this.listaboutdata=this.listhome[2].list;
          this.listProdata=this.listhome[3].list;
        })
      },
      getimgsrc(imgvalue) {
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      }
    },
  }
</script>

<style lang="less" scoped>

  // 大于800px
  @media only screen and (min-width: 800px) {
    .homecontainer {
      font-size: 1vw;

      .subdiv {
        width: 100%;
        display: flex;
        justify-content: space-around;
        font-size: .5em;

        .left {
          width: 48%;
          height: 100%;
          font-size: .8em;
        }

        .right {
          width: 48%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    ._homecontainer {
      font-size: 1.5vw;

      ._subdiv {
        width: 100%;
        display: flex;
        flex-direction: column;
        // justify-content: space-around;
        font-size: .5em;

        .left {
          width: 100%;
          height: 100%;
          font-size: .8em;
        }

        .right {
          width: 100%;
          height: 100%;
          font-size: .8em;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Home/Home.vue